/* Stylesheet */

.info_message {
  margin: 92px 0px 92px 0px;

  .title {
    margin: 32px 0px 32px 0px;
    font-size: 28px;

    span {
      font-weight: 600;
    }
  }
}

.social_links {
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    margin: 0px 12px 0px 0px;
  }

  .fab_button {
    height: 42px;
    width: 42px;
    --background: var(--ion-color-primary);
  }
}
